import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ep-egg-fireworks',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './fireworks.component.html'
    //,styleUrls: ['./fireworks.component.scss']
})

export class FireworksComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {

    }
}
